module.exports = __webpack_public_path__ + "res/img_ph_2.41f3f771107e971497c6b54abf40088c.png";